// extracted by mini-css-extract-plugin
module.exports = {"Spacer":"Spacer_Spacer__22fM1"};